import { jsx as _jsx } from "react/jsx-runtime";
import { AvatarGroup } from '@tribeplatform/react-ui-kit/Avatar';
import { MemberAvatar } from './MemberAvatar';
export const MembersAvatars = ({ ids, moreCount }) => {
    if (!(ids === null || ids === void 0 ? void 0 : ids.length)) {
        return null;
    }
    return (_jsx(AvatarGroup, { moreCount: moreCount, children: ids.map(memberId => {
            return _jsx(MemberAvatar, { id: memberId }, memberId);
        }) }, void 0));
};
//# sourceMappingURL=MembersAvatars.js.map